export class PausedEvent {
    constructor({ transfer }) {
        this.name = 'paused';
        this.transfer = { ...transfer };
    }
    get data() {
        return {
            transfer: this.transfer,
        };
    }
}
